import { atom } from "jotai";

export const notificationQRPopupAtom = atom ( false );
